import { Subject, takeUntil } from 'rxjs';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { Component, OnInit, Input, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';

import { MemoryCard } from './memory-card';
import { GameService } from './game.service';
import { MobileThemeService } from '@sifca-monorepo/clients';

@Component({
  template: '',
})
export class MobileMemoryCardComponent implements OnInit, OnChanges {
  private unsubscribeAll: Subject<any> = new Subject<any>();
  
  @Input() id: number;
  @Input() picture: MemoryCard;
  @Input() timerOn: boolean;

  darkMode;
  isRotated: boolean;
  isCardDisabled = false;
  faQuestion = faQuestion;
  
  constructor(private gameService: GameService, private cd: ChangeDetectorRef, private themeService: MobileThemeService) {}

  ngOnInit(): void {
    this.themeService.darkMode$.pipe(takeUntil(this.unsubscribeAll)).subscribe((darkMode) => {
      this.darkMode = darkMode;
      this.cd.detectChanges();
    });
    this.gameService.isCardDisabled$.subscribe((isCardDisabled) => {
      this.isCardDisabled = isCardDisabled;
    });
    this.gameService.getCoveredCards().subscribe((r) => {
      this.isCardDisabled = false;
      this.cd.markForCheck();
      return r.map((v) => (this.isRotated = v.id == this.id ? false : this.isRotated));
    });
    this.cd.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.picture || changes.id) {
      this.isRotated = false;
    }
    if (changes.timerOn && !this.timerOn) {
      this.isRotated = false;
    }
  }

  onClick() {
    if (!this.isCardDisabled && this.timerOn) {
      this.isRotated = true;
      this.gameService.controlCards({ id: this.id, baseUrl: this.picture?.baseUrl, path: this.picture?.path });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
